import React, { useRef } from "react";
import { CircularProgress, Snackbar, Alert } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

import { CustomInput } from "../../components/Common/CustomInputs";
import { CustomBtn } from "../../components/Common/CustomBtn";
import { getInitials } from "../../components/ui/Gapper";
import { colors } from "../../theme/theme";
import { useBasicProfile } from "./BasicProfile.hooks";
import {
  SectionCard,
  SectionTitle,
  FieldGrid,
  AvatarRow,
  ProfileAvatar,
  AvatarName,
  AvatarSubtitle,
  AvatarWrap,
  AvatarEditButton,
  SaveBar,
} from "../Content/MyProfile/MyProfile.styles";

const BasicProfile = () => {
  const { form, saving, uploading, setField, handleUpload, handleSubmit, snack, closeSnack } =
    useBasicProfile();
  const fileRef = useRef(null);

  const fullName = `${form.firstName} ${form.lastName}`.trim();

  const SaveButton = (
    <CustomBtn
      text={saving ? "Saving..." : "Save Changes"}
      onClick={handleSubmit}
      disabled={saving}
      noMb
      noMt
    />
  );

  return (
    <div>
      <SectionCard>
        <AvatarRow>
          <AvatarWrap>
            <ProfileAvatar src={form.avatar || undefined}>
              {uploading ? (
                <CircularProgress size={20} sx={{ color: colors.white }} />
              ) : (
                getInitials(fullName || "?")
              )}
            </ProfileAvatar>
            <AvatarEditButton
              type="button"
              onClick={() => fileRef.current?.click()}
              aria-label="Upload photo"
            >
              <PhotoCameraIcon />
            </AvatarEditButton>
          </AvatarWrap>
          <div>
            <AvatarName>{fullName || "Your name"}</AvatarName>
            <AvatarSubtitle>{form.email}</AvatarSubtitle>
          </div>
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f) handleUpload(f);
              e.target.value = "";
            }}
          />
        </AvatarRow>
      </SectionCard>

      <SectionCard>
        <SectionTitle>
          <PersonOutlineIcon fontSize="small" /> Account Information
        </SectionTitle>
        <FieldGrid>
          <CustomInput
            label="First Name"
            required
            value={form.firstName}
            setValue={(v) => setField("firstName", v)}
            noIcon
          />
          <CustomInput
            label="Last Name"
            required
            value={form.lastName}
            setValue={(v) => setField("lastName", v)}
            noIcon
          />
          {/* Email is read-only — changing it needs a verified flow. */}
          <CustomInput label="Email" value={form.email} setValue={() => {}} noIcon />
        </FieldGrid>
      </SectionCard>

      <SaveBar>{SaveButton}</SaveBar>

      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={closeSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={closeSnack} severity={snack.severity} variant="filled">
          {snack.msg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default BasicProfile;
